export default "__VITE_ASSET__DHMUrdBt__"